import React, { useReducer } from "react";
import { Button, TextField, InputLabel } from "@mui/material";
import authService from "services/authService";
import { forgotFormReducer } from "reducers/formReducers";
import PropTypes from "prop-types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import tagAdminConstants from "constants/tagAdminConstants";

const initialValue = {
  email: "",
  errors: { email: "" },
};

function ForgotPasswordForm({ responseFunc, loadingStatusFunc }) {
  const [formState, dispatch] = useReducer(forgotFormReducer, initialValue);
  const { email, errors } = formState;
  const onChange = (e) => {
    dispatch({
      type: e.target.name,
      payload: {
        field: e.target.name,
        value: e.target.value,
      },
    });
    dispatch({ type: "validation", errors: initialValue.errors });
  };

  const validateForm = () => {
    let formIsValid = true;
    const pattern = tagAdminConstants.EMAIL_PATTERN_REGEX;
    const issues = {};
    if (!email.value) {
      formIsValid = false;
      issues.email = "*Please enter your email.";
    }
    if (email && !pattern.test(email.value)) {
      formIsValid = false;
      issues.email = "*Please enter valid email.";
    }
    dispatch({
      type: "validation",
      payload: {
        issues,
      },
    });
    return formIsValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationResults = validateForm();
    if (validationResults) {
      loadingStatusFunc(true);
      authService.resetUserPassword(email.value).then((result) => {
        loadingStatusFunc(false);
        responseFunc(result);
      });
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className=" b-forgotform-container" id="underlinehide">
        <InputLabel className="default-label-text" htmlFor="email">
          Email
        </InputLabel>
        <TextField
          name="email"
          id="email"
          onChange={onChange}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          className="default-text-fields"
          value={email.value}
        />
        {errors && errors?.issues !== "" && (
          <div className="b-loginform-container__errorMsg errorMsg">
            {errors?.issues?.email}
          </div>
        )}
      </div>
      <div className=" b-forgotform-container__head">
        <Button
          className="b-forgotform-container__button"
          variant="outlined"
          type="submit"
        >
          <span className="form-button-text"> Send Instructions </span>
        </Button>
      </div>
      <div className="b-forgotform-container__login-back-btn">
        <Link className="b-forgotform-container__back-btn-link" to="/">
          <span>
            <ArrowBackIcon className="b-forgotform-container__back-btn-icon" />
          </span>
          <span className="b-forgotform-container__back-btn-link-text">
            Back to Log In
          </span>
        </Link>
      </div>
    </form>
  );
}

ForgotPasswordForm.propTypes = {
  responseFunc: PropTypes.func.isRequired,
  loadingStatusFunc: PropTypes.func.isRequired,
};

export default ForgotPasswordForm;
